import script from "./AccountsPageBillingCreator.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountsPageBillingCreator.vue?vue&type=script&setup=true&lang=js"

import "./AccountsPageBillingCreator.vue?vue&type=style&index=0&id=484e7bd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-484e7bd8"]])

export default __exports__